<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <path d="M2 14.5H15" stroke="#E5E5E5" stroke-width="1.4" stroke-linecap="round"/>
  <path d="M3 14.5V3H6V14.5" stroke="#E5E5E5" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  <rect x="3.6" y="4.5" width="1.8" height="7.5" rx="0.4" fill="#E5E5E5"/>
  <path d="M8 14.5V10.5H12V14.5" stroke="#E5E5E5" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9 10.5V5.5" stroke="#E5E5E5" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M11 6.5H14.5V10" stroke="#E5E5E5" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
